import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dl-icon-comment",
  "use": "dl-icon-comment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dl-icon-comment\">\n  <path d=\"M17 9H7V7H17V9Z\" fill=\"currentColor\" />\n  <path d=\"M7 13H17V11H7V13Z\" fill=\"currentColor\" />\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 18V2H22V18H16V22H14C11.7909 22 10 20.2091 10 18H2ZM12 16V18C12 19.1046 12.8954 20 14 20V16H20V4H4V16H12Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol